/* Instant Checkout: send buyers straight to checkout after Add to Cart.
   Added by Replit Agent. Remove this file + its include in layout/theme.liquid to revert. */
(function () {
  var BUSY_ATTR = 'data-instant-checkout-busy';

  function addAndCheckout(form, btn) {
    if (form.getAttribute(BUSY_ATTR) === '1') return; // in-flight lock
    // Run native/browser validation (required selects, quantity, and any
    // required inputs injected by option apps like VO / Easify)
    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

    form.setAttribute(BUSY_ATTR, '1');
    var textSpan = btn && btn.querySelector('.js-product-add-to-cart-button-text');
    var originalText = textSpan ? textSpan.textContent : null;
    if (btn) btn.disabled = true;
    if (textSpan) textSpan.textContent = 'Processing...';

    var fd = new FormData(form);
    if (!fd.has('id')) {
      // No variant id — let the theme handle it normally
      form.removeAttribute(BUSY_ATTR);
      if (btn) btn.disabled = false;
      if (textSpan && originalText !== null) textSpan.textContent = originalText;
      return;
    }

    // OSO custom options integration: validate and add option add-on items
    var fetchOpts;
    if (window.OSO && window.OSO.active) {
      if (!window.OSO.ready) {
        // Schema still loading (or failed) — never fall back to plain add-to-cart
        form.removeAttribute(BUSY_ATTR);
        if (btn) btn.disabled = false;
        if (textSpan && originalText !== null) textSpan.textContent = originalText;
        alert('Product options are still loading. Please wait a moment and try again.');
        return;
      }
      if (!window.OSO.validate()) {
        form.removeAttribute(BUSY_ATTR);
        if (btn) btn.disabled = false;
        if (textSpan && originalText !== null) textSpan.textContent = originalText;
        return;
      }
      var items;
      try {
        var mainQty = parseInt(fd.get('quantity'), 10);
        if (!isFinite(mainQty) || mainQty < 1) mainQty = 1;
        if (mainQty > 99) mainQty = 99;
        // Group id lets the cart-transform function merge these lines into one
        var groupId = 'oso-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
        // Per-unit configuration: each add-on charge applies once per main unit
        var addons = window.OSO.addonItems().map(function (it) {
          it.quantity = (it.quantity || 1) * mainQty;
          it.properties = it.properties || {};
          it.properties._oso_group = groupId;
          return it;
        });
        var mainProps = window.OSO.mainProperties();
        mainProps._oso_group = groupId;
        mainProps._oso_main = '1';
        // Serialize visible selections so the merge function can re-attach
        // them to the single merged line
        var pairs = [];
        for (var pk in mainProps) {
          if (Object.prototype.hasOwnProperty.call(mainProps, pk) && pk.charAt(0) !== '_') {
            pairs.push([pk, mainProps[pk]]);
          }
        }
        // Keep as many selection pairs as fit in 8000 chars (never drop all)
        var serialized = JSON.stringify(pairs);
        while (serialized.length > 8000 && pairs.length > 1) {
          pairs.pop();
          serialized = JSON.stringify(pairs);
        }
        if (serialized.length <= 8000) mainProps._oso_props = serialized;
        items = [{
          id: Number(fd.get('id')),
          quantity: mainQty,
          properties: mainProps
        }].concat(addons);
      } catch (err) {
        form.removeAttribute(BUSY_ATTR);
        if (btn) btn.disabled = false;
        if (textSpan && originalText !== null) textSpan.textContent = originalText;
        alert(err.message);
        return;
      }
      fetchOpts = {
        method: 'POST',
        body: JSON.stringify({ items: items }),
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
      };
    } else {
      fetchOpts = { method: 'POST', body: fd, headers: { Accept: 'application/json' } };
    }

    fetch('/cart/add.js', fetchOpts)
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (j) {
            throw new Error(j.description || j.message || 'Could not add to cart');
          });
        }
        return r.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        form.removeAttribute(BUSY_ATTR);
        if (btn) btn.disabled = false;
        if (textSpan && originalText !== null) textSpan.textContent = originalText;
        alert(err.message || 'Could not add this item to the cart. Please try again.');
      });
  }

  // Mouse/touch path: pre-empt the theme's drawer click handler (capture phase)
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('button[type="submit"][name="add"], .js-product-add-to-cart-button');
      if (!btn) return;
      var form = btn.closest('form[action*="/cart/add"]');
      if (!form) return;
      if (btn.disabled || btn.classList.contains('disabled')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addAndCheckout(form, btn);
    },
    true
  );

  // Keyboard / programmatic path: Enter key fires submit directly
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var btn = form.querySelector('button[type="submit"][name="add"], .js-product-add-to-cart-button');
      addAndCheckout(form, btn);
    },
    true
  );
})();
